import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "home",
  "use": "home-usage",
  "viewBox": "0 0 768 768",
  "content": "<symbol viewBox=\"0 0 768 768\" id=\"home\"><path d=\"M319.5 640.5h-159V384h-96L384 96l319.5 288h-96v256.5h-159v-192h-129v192z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/home.svg
// module id = vIvP
// module chunks = 1